import {
  ListStoreDefault,
  ListRequestHandler,
  ListFilterHandler,
  ListSuccessHandler,
 } from 'js/helpers/reducers.js';

import {
  FETCH_KEYWORDS_LIST,
  FETCHED_KEYWORDS_LIST,
  SET_KEYWORDS_FILTER,
} from 'components/Global/Filters/actions.js';

const defaultState = {
  keywordsList: ListStoreDefault({
    pageNum: 1,
    pageSize: 40,
    searchQuery: '',
    searchBy: '',
  }),
};

const KeywordsListReducer = (state = defaultState, action) => {
  switch (action.type) {
    case '@@router/LOCATION_CHANGE':
      return Object.assign({}, defaultState);
    case FETCH_KEYWORDS_LIST:
      return ListRequestHandler(state, action, 'keywordsList');
    case FETCHED_KEYWORDS_LIST:
      return ListSuccessHandler(state, action, 'keywordsList');
    case SET_KEYWORDS_FILTER:
      return ListFilterHandler(state, action, 'keywordsList');
    default:
      return Object.assign({}, state);
  }
};

export default KeywordsListReducer;
